import type { Reducer } from 'redux';
import { produce } from 'immer';
import type { DeleteInviteActions } from './types/actions.types';
import { defaultState, Fields } from './data/DeleteInviteState';
import DeleteInviteConstants from './constants';

const reducer: Reducer<Fields, DeleteInviteActions> = (state = defaultState, action) => {
  return produce<Fields>(state, (draft) => {
    switch (action.type) {
      case DeleteInviteConstants.OPEN_DELETE_INVITATION_MODAL:
        draft.isModalOpen = true;
        draft.invite = action.invite;
        return draft;

      case DeleteInviteConstants.DELETE_INVITATION_REQUEST:
        draft.isLoading = true;
        delete draft.error;
        return draft;

      case DeleteInviteConstants.CLOSE_DELETE_INVITATION_MODAL:
      case DeleteInviteConstants.DELETE_INVITATION_REQUEST_SUCCESS:
        return {
          ...defaultState,
        };

      case DeleteInviteConstants.DELETE_INVITATION_REQUEST_ERROR:
        draft.isLoading = false;
        draft.error = action.error;
        return draft;

      default:
        return state;
    }
  });
};

export default reducer;
